import axios from 'axios'
import { boot } from 'quasar/wrappers'

/**
 * `$axios` on every component instance.
 *
 * Was `Vue.prototype.$axios = axios` at module scope. Vue 3 has no shared constructor to hang a
 * property on -- instance properties belong to an app, so this has to run inside `boot()` where
 * Quasar hands one over.
 */
export default boot(({ app }) => {
  app.config.globalProperties.$axios = axios
})
